import React, { useContext, useEffect, useState } from 'react';
import MainProdavnica from './components/MainProdavnica';
import FilterProdavnica from './components/FilterProdavnica';
import { TabContext } from '../../../Context/TabContext';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import DetailView from './components/DetailView';
import useHttp from '../../../hooks/use-http';
import { urls } from './api/urls';
import toast from 'react-hot-toast';
import Pagination from '@mui/material/Pagination';
import './index.css';
import { useTranslation } from 'react-i18next';

const INITIAL_VALUES = {
  idKupca: +localStorage.idFirme,
  lista: [],
  uslovPretrage: '',
  offset: 0,
  next: 12, // broj artikala po stranici
};

const Prodavnica = ({ numberOfArticles, handleShop, shop }) => {
  const { t, i18n } = useTranslation();
  const [pretraga, setPretraga] = useState(false);
  const [selectedMasine, setSelectedMasine] = useState([]);
  const { addTab } = useContext(TabContext);
  const [openDetalView, setOpenDetalView] = useState(false);
  const [dataDeo, setDataDeo] = useState({});
  const [deloviPregledFavorite, setDeloviPregledFavorite] = useState([]);
  const { sendRequest, getData, data, isLoading } = useHttp('');
  const [masineZakupca, setMasineZaKupca] = useState([]);
  const [filterData, setFilterData] = useState(INITIAL_VALUES);
  const [deloviPregled, setDeloviPregled] = useState([]);
  const [quantity, setQuantity] = useState(0);
  const [totalItems, setTotalItems] = useState(filterData.brojDelova || 0); // Ukupan broj artikala

  const vratiKolicinu = async () => {
    const config = {
      method: 'POST',
      url: urls.KOLICINA_U_KORPI,
      data: {
        id: +localStorage.idFirme,
      },
    };
    const response = await getData(config);
    numberOfArticles(response.kolicinaUKorpi);
    console.log(response);
  };
  useEffect(() => {
    vratiKolicinu();
  }, []);

  useEffect(() => {
    const vratiDelovePregled = async () => {
      const config = {
        method: 'POST',
        url: urls.VARATI_DELOVE_PREGLED,
        data: { idKupca: +localStorage.idFirme },
      };
      const response = await getData(config);
      if (response.length > 0) {
        setDeloviPregledFavorite(response);
      } else {
        setDeloviPregledFavorite([]);
      }
    };

    const vratiMasine = async () => {
      const config = {
        method: 'POST',
        url: urls.GET_MASINE_ZA_KUPCA,
        data: {
          id: +localStorage.idFirme,
          idKorProm: +localStorage.idKorisnika,
        },
      };

      const response = await getData(config);
      setMasineZaKupca(response);
    };

    vratiDelovePregled();
    vratiMasine();
  }, []);

  useEffect(() => {
    const vratiDeloveInitials = async () => {
      const config = {
        method: 'POST',
        url: urls.VARATI_DELOVE_FILTER,
        data: {
          ...filterData,
          idKorProm: +localStorage.idKorisnika,
          idKupca: +localStorage.idFirme,
        },
      };

      const response = await getData(config);
      setDeloviPregled(response || []);
      if (response.length > 0) {
        setTotalItems(response[0].brojDelova || 0);
      } // Pretpostavka: server vraća ukupan broj artikala
    };

    vratiDeloveInitials();
  }, [filterData.offset, filterData.next]);

  const handleClickDokument = (item) => {
    const tab = {
      title: 'Korpa',
      icon: 'fa fa-shopping-cart',
      type: 10018,
      data: item,
    };
    addTab(tab);
  };

  useEffect(() => {
    if (shop) {
      handleShop(false);
      handleClickDokument();
      console.log('test');
    }
  }, [shop]);

  const handleShopClick = async (e, item) => {
    e.stopPropagation();
    numberOfArticles((prevCount) => prevCount + 1);
    const config = {
      method: 'POST',
      url: urls.DODAVANJE_U_KORPU,
      data: {
        idKorProm: +localStorage.idKorisnika,
        idKupca: +localStorage.idFirme,
        idMasine: item.idMasine,
        idDela: item.id,
        kolicina: null,
        indikator: 1,
      },
    };
    const response = await getData(config);
    if (response.opis) {
      toast.success(t('messages.addedItemInCart'));
    } else {
      toast.error(handleErrorMessage(response));
    }
    console.log(response);
  };

  const handleOpenDetail = async (e, product) => {
    setDataDeo(product);
    setOpenDetalView(true);

    const config = {
      method: 'POST',
      url: urls.KOLICINA_ZA_DEO,
      data: {
        idKupca: +localStorage.idFirme,
        idDela: product.id,
      },
    };
    const response = await getData(config);
    console.log(response);
    setQuantity(response.kolicina || 0);
  };

  const handleSaveNumber = async (e, product) => {
    console.log(product);
    console.log(quantity);
    const config = {
      method: 'POST',
      url: urls.DODAVANJE_U_KORPU,
      data: {
        idKorProm: +localStorage.idKorisnika,
        idKupca: +localStorage.idFirme,
        idMasine: product.idMasine,
        idDela: product.id,
        kolicina: quantity,
        indikator: 2,
      },
    };
    const response = await getData(config);
    vratiKolicinu();
    console.log(response);
    setOpenDetalView(false);
  };

  const handlePageChange = (event, value) => {
    const offset = (value - 1) * filterData.next;
    setFilterData((prev) => ({ ...prev, offset }));
  };

  const totalPages = Math.ceil(totalItems / filterData.next);
  const filterMasineKlik = async () => {
    const config = {
      method: 'POST',
      url: urls.VARATI_DELOVE_FILTER,
      data: {
        ...filterData,
        idKorProm: +localStorage.idKorisnika,
        idKupca: +localStorage.idFirme,
      },
    };

    const response = await getData(config);
    setDeloviPregled(response || []);
    if (response.length > 0) {
      setTotalItems(response[0].brojDelova || 0);
    }
  };

  return (
    <div style={{ marginBottom: '30px' }}>
      <FilterProdavnica
        filterData={filterData}
        setFilterData={setFilterData}
        listaMasina={masineZakupca}
        handleOpenDetail={handleOpenDetail}
        filterMasine={filterMasineKlik}
      />
      <MainProdavnica
        deloviPregled={deloviPregled}
        deloviPregledFavorite={deloviPregledFavorite}
        handleShopClick={handleShopClick}
        handleOpenDetail={handleOpenDetail}
      />
      <Pagination
        count={totalPages}
        page={Math.ceil(filterData.offset / filterData.next) + 1}
        onChange={handlePageChange}
        style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}
      />
      <MuiDialog
        maxWidth="md"
        open={openDetalView}
        title="Details"
        content={
          <DetailView
            item={dataDeo}
            handleSaveNumber={handleSaveNumber}
            quantity={quantity}
            setQuantity={setQuantity}
          />
        }
        handleClose={() => setOpenDetalView(false)}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default Prodavnica;
